// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `ion-item {
  --padding-start: 0px;
  border: 1px solid black;
  border-radius: 5px;
  padding-left: 10px;
}`, "",{"version":3,"sources":["webpack://./src/app/components/calendar/calendar.component.scss"],"names":[],"mappings":"AAAA;EACI,oBAAA;EACA,uBAAA;EACA,kBAAA;EACA,kBAAA;AACJ","sourcesContent":["ion-item {\r\n    --padding-start: 0px;\r\n    border: 1px solid black;\r\n    border-radius: 5px;\r\n    padding-left: 10px;\r\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
